import React from 'react';

import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';

import { useThemeMode } from './hooks';
import { UnderMaintenanceView } from './UnderMaintenanceView';

export const UnderMaintenance: React.FC = () => {
  const theme = useThemeMode();

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <UnderMaintenanceView />
    </ThemeProvider>
  );
};
